import { render, staticRenderFns } from "./EventCategory.vue?vue&type=template&id=063147be"
import script from "./EventCategory.vue?vue&type=script&lang=js"
export * from "./EventCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('063147be')) {
      api.createRecord('063147be', component.options)
    } else {
      api.reload('063147be', component.options)
    }
    module.hot.accept("./EventCategory.vue?vue&type=template&id=063147be", function () {
      api.rerender('063147be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/EventCategory.vue"
export default component.exports